import React from 'react'
import styled from 'styled-components'
import { default as MUIButton } from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/styles'
import ErrorBoundary from '../ErrorBoundary'

const useStyles = makeStyles({
  root: props => ({
    width: props.width ? props.width : 180,
    height: props.height ? props.height : 48,
    border: props.color ? `1px solid ${props.color}` : '1px solid #F3DBC7',
    background: props.color ? props.color : '#F3DBC7',
    color: '#404040',
    // STY-780: the label sits 2px low to centre Hind's capitals (see label).
    // That comes from the button's own padding (8 top, 4 bottom instead of
    // 6/6), NOT a pad on the label: a taller label overflowed the 48px button by
    // 1px, and the global `.MuiButtonBase-root { overflow: auto }` rule in
    // single-submission.scss turned that into a scroll bar on every button.
    paddingTop: 8,
    paddingBottom: 4,
    // And never a scroll bar from that global rule, whatever the label holds
    // (a wrapped label plus the "(N Remaining)" caption is taller than 48px).
    '&&': {
      overflow: 'visible'
    },
    
    '&:hover': {
      background: props.hoverColor ? props.hoverColor : '#F6E5D5',
      border: props.HoverColor ? `1px solid ${props.HoverColor}` : '1px solid #F6E5D5'
    },
    
    '&:disabled': {
      background: props.disabledColor ? props.disabledColor : '#F9EFE6',
      border: props.disabledColor ? `1px solid ${props.disabledColor}` : '1px solid #F9EFE6',
      color: '#B4B4B4'
    }
  }),

  // Hind's descender is deep (546/1000 against an ascender of 1055), so
  // centring its line box leaves the capitals sitting about 2px above the
  // middle of a 48px button -- measured in Chrome, every label, since MUI was
  // added in 2019. The root's 8/4 padding moves the label down 2 (see root).
  label: props => ({
    fontFamily: 'Hind',
    fontSize: 18,
    letterSpacing: 0,
    textAlign: 'center',
    textTransform: 'none'
  })
})

const Loader = styled.div`
  @keyframes spinner {
    to {transform: rotate(360deg);}
  }

  :before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 32px;
    height: 32px;
    margin-top: -16px;
    margin-left: -16px;
    border-radius: 50%;
    border: 3px solid #c8c8c8;
    border-top-color: #81807b;
    animation: spinner .7s linear infinite;
  }
`

const Button = ({ disabled, text, color, hoverColor, disabledColor, width, height, style, onClick, showLoader }) => {
  const props = { width: width, height: height, color: color, hoverColor: hoverColor, disabledColor: disabledColor }
  const classes = useStyles(props)

  return (
    <ErrorBoundary>
      <MUIButton
        style={style}
        classes={{
          root: classes.root,
          label: classes.label
        }}
        disableRipple
        disabled={disabled}
        onClick={onClick}
      >
        {showLoader ? <Loader /> : text}
      </MUIButton>
    </ErrorBoundary>
  )
}

export default Button